module.exports = __webpack_public_path__ + "static/bro11-e0839e0b4bfbf4c7bd185273471ae36b.jpg";